import { SimpleTabsProvider } from 'contexts/SimpleTabsContext';

import ProviderPlanning from '../context/ContextPrevision';
import { SCREEN_TYPE_TO_ENUM_MAPPING } from '../context/types/contextPrevision.type';

interface ICollaborationProps {
	screenType: SCREEN_TYPE_TO_ENUM_MAPPING;
}

export default function RegisterCollaboration({
	screenType,
}: ICollaborationProps) {
	return (
		<SimpleTabsProvider>
			<ProviderPlanning screenType={screenType} />
		</SimpleTabsProvider>
	);
}
